module.exports = __webpack_public_path__ + "img/sphere6.93008dc9.svg";